// src/pages/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import SobreNosotros from '../SobreNosotros/SobreNosotros';
function Home() {
  return (
    <div>
      <SobreNosotros/>
    </div>
  );
}

export default Home;